export default __webpack_public_path__ + "static/media/Kollitikes_tainies_PPL.e898fd01.jpg";